import React from "react"

import HeroGridComponent from "./HeroGrid"

import heroFactory from "./herogrid.factory"

export { default as HeroImages } from "./HeroImages"

export const HeroGrid = props => {
  const {
    children,
    page,
    theme,
    color,
    analytics,
    shortHeroSection,
    largeBaseHeaderSection,
    content,
    classes,
    levels
  } = props
  const componentProps = {
    children,
    page,
    theme,
    color,
    analytics,
    shortHeroSection,
    largeBaseHeaderSection,
    ...heroFactory.transform(content, classes, levels, page)
  }
  return <HeroGridComponent {...componentProps} />
}
